
import React, { Fragment } from "react";

import SweetAlert from 'sweetalert2';
import { toast } from "react-toastify";

import { documentsService } from 'Services';
import TableRowDelete from 'CommonElements/Table/TableRowDelete';


const DeleteDocument = ({ data={}, loadData }) => {


  const deleteDocument = () => {
    SweetAlert.fire({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to recover this record!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true,
    }).then((result) => {
        if (result.value) {
            documentsService.deleteDocument(data.id).then(res => {
                toast.success('Document deleted, successfully');
                loadData();
            }).catch(err => {
                toast.error('Failed to delete Document');

            })
        }
    });
};
  return (
    <Fragment>
        <TableRowDelete onClick={deleteDocument} />

    </Fragment>
  );
};

export default DeleteDocument;
